import React, { useMemo } from "react";
import { groupBy } from "lodash-es";
import { getDocumentGroup } from "../../services/faDocumentationService";
import "./FacesheetFAP.scss";
import { FacesheetFAP } from "./FacesheetFAP";
import {
    otherDocumentOptions,
    personalVerificationInformationDocumentOptions,
    proofOfIncomeDocumentOptions,
    taxInformationDocumentOptions,
} from "../../containers/UmmcFADocumentation/UmmcFaDropDownConstants";
import { LoadingBar } from "../LoadingComponents/LoadingBar";

export const FacesheetFAPDocumentGroup = ({
    faDocumentation,
    isFaDocumentationLoading,
    financialDocumentsDropDownItems,
    printedPdfs,
}) => {
    const initialValues = useMemo(() => {
        if (isFaDocumentationLoading) {
            return null;
        }

        const documentsWithGroup = faDocumentation?.map(x => {
            const documentGroup = getDocumentGroup(x.documentName);
            return {
                ...x,
                group: documentGroup == null ? "faDocuments" : documentGroup,
            };
        });

        let result = groupBy(documentsWithGroup, x => x.group);

        result.faDocuments?.map(x => {
            let document = printedPdfs?.filter(y => y.templateKey === x.documentName);
            x.printedDate = document?.length > 0 ? document[0]?.printDate : null;
        });

        return result;
    }, [isFaDocumentationLoading, faDocumentation, printedPdfs]);

    return (
        <>
            {(initialValues?.faDocuments === undefined ||
                initialValues?.faDocuments === null ||
                initialValues?.faDocuments?.length <= 0) &&
                (initialValues?.taxInformationDocuments === undefined ||
                    initialValues?.taxInformationDocuments === null ||
                    initialValues?.taxInformationDocuments?.length <= 0) &&
                (initialValues?.proofOfIncome === undefined ||
                    initialValues?.proofOfIncome === null ||
                    initialValues?.proofOfIncome?.length <= 0) &&
                (initialValues?.personalVerificationDocuments === undefined ||
                    initialValues?.personalVerificationDocuments === null ||
                    initialValues?.personalVerificationDocuments?.length <= 0) &&
                (initialValues?.otherDocuments === undefined ||
                    initialValues?.otherDocuments === null ||
                    initialValues?.otherDocuments?.length <= 0) && (
                    <div className="facesheet_faDocuments">
                        <div className="uploaded-faDocuments">
                            <LoadingBar isLoading={isFaDocumentationLoading}>
                                <div>
                                    <div> No data found</div>
                                </div>
                            </LoadingBar>
                        </div>
                    </div>
                )}

            {initialValues?.faDocuments !== undefined &&
                initialValues?.faDocuments !== null &&
                initialValues?.faDocuments?.length > 0 && (
                    <FacesheetFAP
                        isFaDocumentationLoading={isFaDocumentationLoading}
                        faDocumentation={initialValues?.faDocuments}
                        hasPrintedDate={true}
                        title={"Financial Assistance Documents"}
                        documentDropdownItems={financialDocumentsDropDownItems}
                    />
                )}
            {initialValues?.taxInformationDocuments !== undefined &&
                initialValues?.taxInformationDocuments !== null &&
                initialValues?.taxInformationDocuments?.length > 0 && (
                    <FacesheetFAP
                        isFaDocumentationLoading={isFaDocumentationLoading}
                        faDocumentation={initialValues?.taxInformationDocuments}
                        hasPrintedDate={false}
                        title={"Tax Information"}
                        documentDropdownItems={taxInformationDocumentOptions}
                    />
                )}
            {initialValues?.proofOfIncome !== undefined &&
                initialValues?.proofOfIncome !== null &&
                initialValues?.proofOfIncome?.length > 0 && (
                    <FacesheetFAP
                        isFaDocumentationLoading={isFaDocumentationLoading}
                        faDocumentation={initialValues?.proofOfIncome}
                        hasPrintedDate={false}
                        title={"Proof of Income"}
                        documentDropdownItems={proofOfIncomeDocumentOptions}
                    />
                )}
            {initialValues?.personalVerificationDocuments !== undefined &&
                initialValues?.personalVerificationDocuments !== null &&
                initialValues?.personalVerificationDocuments?.length > 0 && (
                    <FacesheetFAP
                        isFaDocumentationLoading={isFaDocumentationLoading}
                        faDocumentation={initialValues?.personalVerificationDocuments}
                        hasPrintedDate={false}
                        title={"Personal Verification Information"}
                        documentDropdownItems={personalVerificationInformationDocumentOptions}
                    />
                )}
            {initialValues?.otherDocuments !== undefined &&
                initialValues?.otherDocuments !== null &&
                initialValues?.otherDocuments?.length > 0 && (
                    <FacesheetFAP
                        isFaDocumentationLoading={isFaDocumentationLoading}
                        faDocumentation={initialValues?.otherDocuments}
                        hasPrintedDate={false}
                        title={"Other Information"}
                        documentDropdownItems={otherDocumentOptions}
                    />
                )}
        </>
    );
};
